import { render, staticRenderFns } from "./CommentSection.vue?vue&type=template&id=1b2bbc2a&scoped=true&"
import script from "./CommentSection.vue?vue&type=script&lang=js&"
export * from "./CommentSection.vue?vue&type=script&lang=js&"
import style0 from "./CommentSection.vue?vue&type=style&index=0&id=1b2bbc2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2bbc2a",
  null
  
)

export default component.exports